import { Component, OnInit } from '@angular/core';
import { DateRange, DataService, GeneralReportRecord, GeneralReport, ProductUnit } from '@core/services/data.service';
import { DatePickerHandler } from '@common/UI/date-picker/date-picker.component';
import { map } from 'rxjs/operators';
import { SynchronizationService } from '@core/services/synchronization.service';
import { Filterable } from '@common/utilities/Filterable';
import { Recoverable } from 'repl';
import { CurrenciesService } from '@core/services/currencies.service';

interface Record extends GeneralReportRecord {
  Key: string;  
}

@Component({
  selector: 'app-general-report',
  templateUrl: './general-report.component.html',
  styleUrls: ['./general-report.component.scss']
})
export class GeneralReportComponent implements OnInit {

  constructor(private ds: DataService, public currencies: CurrenciesService, private sync: SynchronizationService) { }

  public exchangeRate: number = 3600;

  private keys: { [key: string]: string } = {
    'CustomerDebtIncreasedValue': 'Điều chỉnh tăng công nợ khách hàng',
    'CustomerDebtDecreasedValue': 'Điều chỉnh giảm công nợ khách hàng',
    'CustomerDiscountValue': 'Giảm giá hàng hỏng, lỗi cho khách',
    'CustomerProductExportValue': 'Bán hàng nhập lại của khách',
    'CustomerProductReturnedValue': 'Nhập lại hàng của khách',
    'CustomerProductLostValue': 'Mất hàng nhập từ khách',
    'VendorProductExportValue': 'Bán hàng nhập xưởng',
    'VendorProductReturnedValue': 'Khách trả hàng xưởng',
    'ImportedProductCostExpense': 'Gốc tiền hàng xưởng bán trong kỳ',
    'ReturnedProductCostExpense': 'Tiền nhập hàng từ khách hàng',
    'ServiceExpenseValue': 'Chi phí hoạt động',
    'ServiceIncomeValue': 'Doanh thu từ hoạt động',
    'VendorProductDiscountWorth': 'Xưởng trừ hàng hỏng, lỗi',
    'VendorProductExportWorth': 'Gốc tiền hàng xưởng bán trong kỳ',
    'VendorProductLostWorth': 'Mất hàng nhập từ xưởng',
    'VendorProductReturnedWorth': 'Gốc tiền hàng xưởng khách trả trong kỳ',    
  }

  public name(key: string) {
    return this.keys[key] ? this.keys[key] : key;
  }

  ngOnInit(): void {
  }

  public incomes = new Filterable<Record>();
  public expenses = new Filterable<Record>();

  public get loading(): boolean {
    return this.range && !this.sync.ready(GeneralReportComponent, CurrenciesService);
  }

  public range: { name: string, range: DateRange }

  public handler: DatePickerHandler = {
    change: (info: { name: string, range: DateRange }) => {

      this.range = info;

      this.sync.notify(GeneralReportComponent, false);

      return this.ds.reports('general', { range: info.range }).pipe(map(report => {

        this.sync.notify(GeneralReportComponent, true);

        if (report && report.General) {          

          let records: Record[] = [];

          for (let o in report.General) {
            if (typeof report.General[o] == 'object') {
              records.push({ ...report.General[o], Key: o });
            }
          }

          this.exchangeRate = report.General.ExchangeRate;
          this.incomes.source = records.filter(i => i.Affection == 'income');
          this.expenses.source = records.filter(i => i.Affection == 'expense');

          return true;
        }

        return false;
      }));
    }
  }


  public value(record: GeneralReportRecord, field: 'Debt' | 'Paid' | 'Total', symbol: 'VND' | 'CNY'): number {

    let v: number = 0;

    switch (field) {
      case 'Debt': v = record.Debt; break;
      case 'Paid': v = record.Paid; break;
      case 'Total': return this.value(record, 'Debt', symbol) + this.value(record, 'Paid', symbol);
    }

    if (record.Symbol == symbol) {
      return v;
    }
    else {
      switch (symbol) {
        case 'VND': return v * (field == 'Debt' ? this.currencies.get('CNY').Conversion : this.exchangeRate);
        case 'CNY': return v / (field == 'Debt' ? this.currencies.get('CNY').Conversion : this.exchangeRate);
      }
    }
  }

  public sum(records: GeneralReportRecord[], field: 'Debt' | 'Paid' | 'Total', symbol: 'VND' | 'CNY'): number {
    return records.sum(i => this.value(i, field, symbol));
  }

}
